module.exports = __webpack_public_path__ + "img/icon-prognostic-menu-covid.751e598d.svg";